'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconType", "availableIconTypes", "disabled", "onChange"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFieldset from 'UIComponents/form/UIFieldset';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { IconTypes } from '../../constants/icon';
import { toolbarI18nKey } from '../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => toolbarI18nKey(`iconType.${suffix}`);
const propTypes = {
  iconType: PropTypes.oneOf(Object.values(IconTypes)),
  availableIconTypes: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};
const defaultProps = {
  availableIconTypes: []
};
function IconTypeToolbarControl(props) {
  const {
      iconType,
      availableIconTypes,
      disabled: _disabled,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleTypeChange = evt => {
    const {
      name: selectedType
    } = evt.target;
    if (iconType !== selectedType) {
      onChange(selectedType);
    }
  };
  return /*#__PURE__*/_jsx(UIFieldset, {
    _size: "small",
    children: /*#__PURE__*/_jsx(UIToggleGroup, Object.assign({}, rest, {
      name: "styleType",
      inline: true,
      children: Object.values(IconTypes).map(typeOption => {
        const disabled = !availableIconTypes.includes(typeOption);
        const renderedRadioInput = /*#__PURE__*/_jsx(UIRadioInput, {
          name: typeOption,
          inline: true,
          checked: typeOption === iconType,
          onChange: handleTypeChange,
          disabled: _disabled || disabled,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(typeOption)
          })
        }, typeOption);
        if (disabled) {
          return /*#__PURE__*/_jsx(UITooltip, {
            title: I18n.text(i18nKey('unavailable')),
            placement: "bottom",
            children: renderedRadioInput
          }, `${typeOption}--tooltip`);
        }
        return renderedRadioInput;
      })
    }))
  });
}
IconTypeToolbarControl.propTypes = propTypes;
IconTypeToolbarControl.defaultProps = defaultProps;
IconTypeToolbarControl.displayName = 'IconTypeToolbarControl';
export default IconTypeToolbarControl;